<section class="app-dialog pruebas-dialogo" [attr.aria-busy]="cargando">
  <header class="app-dialog__header">
    <div class="app-dialog__heading">
      <div>
        <p class="app-dialog__eyebrow">Gestión de Proyectos</p>
        <h2 [id]="idTitulo">Vincular incidencia existente</h2>
        <p *ngIf="subtitulo">{{ subtitulo }}</p>
      </div>
    </div>
    <button type="button" class="app-dialog__close app-dialog__close--icono" aria-label="Cerrar" title="Cerrar" (click)="cancelar()">
      <span class="material-icons" aria-hidden="true">close</span>
    </button>
  </header>

  <div mat-dialog-content class="app-dialog__content pruebas-dialogo__contenido">
    <div class="vincular__filtros">
      <div class="vincular__buscar">
        <label for="t2v-buscar">Buscar por folio o título</label>
        <span class="material-icons" aria-hidden="true">search</span>
        <input #campo id="t2v-buscar" type="search" placeholder="Por ejemplo, 33 o ticket" autocomplete="off"
               [value]="busqueda" (input)="buscar(campo.value)" />
      </div>

      <fieldset class="vincular__mostrar">
        <legend class="cdk-visually-hidden">Mostrar</legend>
        <span *ngFor="let opcion of filtros" class="vincular__opcion">
          <input type="radio" name="t2v-filtro" class="cdk-visually-hidden" [id]="'t2v-f-' + opcion.clave" [value]="opcion.clave"
                 [checked]="filtro === opcion.clave" (change)="cambiarFiltro(opcion.clave)" />
          <label [for]="'t2v-f-' + opcion.clave" [class.is-on]="filtro === opcion.clave">{{ opcion.texto }}</label>
        </span>
      </fieldset>
    </div>

    <output class="vincular__estado" *ngIf="cargando">
      <span class="material-icons" aria-hidden="true">hourglass_top</span>
      Consultando las incidencias de la etapa…
    </output>

    <div class="pruebas-dialogo__aviso" role="alert" *ngIf="!cargando && error">
      <strong>No se pudieron mostrar las incidencias.</strong>
      <p>{{ error }}</p>
      <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="cargar()">Volver a intentar</button>
    </div>

    <div class="table-page__table-wrap vincular__tabla-wrap" *ngIf="!cargando && !error">
      <table class="table-page__table vincular__tabla" *ngIf="filas.length; else sinFilas">
        <caption class="cdk-visually-hidden">{{ descripcionFiltro }}</caption>
        <thead>
          <tr>
            <th scope="col"><span class="cdk-visually-hidden">Seleccionar</span></th>
            <th scope="col">Folio</th>
            <th scope="col">Título</th>
            <th scope="col">Prioridad</th>
            <th scope="col">Estatus</th>
            <th scope="col">Versión detectada</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let fila of filas; trackBy: trackFila" [class.is-elegida]="elegida(fila)">
            <td class="vincular__marca">
              <input type="checkbox" [id]="'t2v-inc-' + fila.incidencia.id" [checked]="elegida(fila)" [disabled]="fila.vinculada"
                     (change)="alternar(fila)" />
            </td>
            <td><strong class="vincular__folio">#{{ fila.incidencia.folio ?? "—" }}</strong></td>
            <td>
              <label class="vincular__titulo" [for]="'t2v-inc-' + fila.incidencia.id">{{ fila.incidencia.titulo || "Sin título" }}</label>
              <span class="table-page__status-badge is-inactive vincular__ya" *ngIf="fila.vinculada">Ya vinculada</span>
            </td>
            <td><span class="app-prioridad" [ngClass]="fila.clasePrioridad">{{ fila.prioridad }}</span></td>
            <td><span class="app-chip-estatus" [ngClass]="fila.claseEstatus">{{ fila.incidencia.estatus || "—" }}</span></td>
            <td class="vincular__version">{{ fila.version }}</td>
          </tr>
        </tbody>
      </table>

      <ng-template #sinFilas>
        <div class="table-page__empty">
          <span class="material-icons" aria-hidden="true">bug_report</span>
          <strong>No hay incidencias que mostrar</strong>
          <span>Prueba con otro filtro o con otra búsqueda.</span>
        </div>
      </ng-template>
    </div>

    <p class="vincular__pie" *ngIf="!cargando && !error">
      <span>Mostrando {{ filas.length }} {{ filas.length === 1 ? "incidencia" : "incidencias" }}</span>
      <span *ngIf="yaVinculadasVisibles">{{ yaVinculadasVisibles }} ya {{ yaVinculadasVisibles === 1 ? "vinculada" : "vinculadas" }} a esta ejecución</span>
      <span *ngIf="consulta?.incompleta">Hay más de 200 en algún estatus: busca por folio si no la ves.</span>
    </p>
  </div>

  <footer mat-dialog-actions class="app-dialog__footer">
    <span class="vincular__seleccion" aria-live="polite">
      <span class="pruebas-dialogo__contador">{{ cuantasSeleccionadas }} {{ cuantasSeleccionadas === 1 ? "seleccionada" : "seleccionadas" }}</span>
      <span class="vincular__folios" *ngIf="cuantasSeleccionadas">{{ foliosSeleccionados }}</span>
    </span>
    <button type="button" class="app-form-btn app-form-btn--secondary" (click)="cancelar()">Cancelar</button>
    <button type="button" class="app-form-btn app-form-btn--primary" [disabled]="!cuantasSeleccionadas" (click)="vincular()">Vincular</button>
  </footer>
</section>
